import { createDraftSafeSelector } from '@reduxjs/toolkit';

import type { RootState } from '@polyai/stream/store';

export const selectCsatSlice = (state: RootState) => state.csat;

export const selectCsatConfig = createDraftSafeSelector(
  [selectCsatSlice],
  csat => csat,
);

export const selectCsatEnabled = createDraftSafeSelector(
  [selectCsatSlice],
  csat => csat?.enabled ?? false,
);
